var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.component)?_c(_vm.component,{tag:"component",attrs:{"playlist":_vm.playlist,"paused":_vm.paused,"loading":_vm.loading,"running":_vm.playlistRunning},on:{"play":_vm.play,"pause":_vm.pause,"delete":_vm.deletePlaylist}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }